import Lottie from 'lottie-react';
import { useState } from 'react';
import {
	Button,
	ColourStateSolid,
	FlexAlign,
	FlexGap,
	FlexJustify,
	Modal,
	ModalType,
	StackVertical,
} from '@ukpostbox/frontend-framework';
import sendStart from '../../../ProfilesUser/Components/Animations/send-start.json';
import sendProcess from '../../../ProfilesUser/Components/Animations/send-process.json';
import sendEnd from '../../../ProfilesUser/Components/Animations/send-end.json';
import { SendDataProcessType } from '../../Types/SendsFormTypes';

interface SendUploadModalType extends ModalType {
	sendData?: SendDataProcessType;
	uploadStartedCallback?: any;
	saveSendStartedCallback?: any;
}

function SendProcessingWizardModal(props: SendUploadModalType) {
	const [startAnimationComplete, setStartAnimationComplete] = useState<boolean>(false);
	const [processAnimationComplete, setProcessAnimationComplete] = useState<boolean>(false);
	const [endAnimationComplete, setEndAnimationComplete] = useState<boolean>(false);

	return (
		<Modal
			title='Send Item'
			lockOpen={props.lockOpen}
			isOpen={props.isOpen}
			closeCallback={() => props.closeCallback()}
		>
			<StackVertical gap={FlexGap.Small} extraClass={endAnimationComplete ? 'sends-complete-shifter' : ''}>
				{!props.sendData?.postingData && (
					<>
						{props.sendData?.form?.file[0] && (
							<object
								data={URL.createObjectURL(props.sendData?.form?.file[0])}
								type='application/pdf'
								style={{ width: '100%', aspectRatio: '1/1.414' }}
								aria-label='File Preview'
							/>
						)}
						<div className='mt-md'>
							<h6 className='m-0'>Recipient</h6>
							<p>{props.sendData?.address}</p>

							<h6 className='m-0'>Postage</h6>
							<p>{props.sendData?.postage}</p>
						</div>
					</>
				)}

				{!props.sendData?.postingData && !props.sendData?.sendComplete && (
					<Button
						title='Looks Good, Send!'
						fullWidth
						colour={ColourStateSolid.Primary}
						onClick={() => props.actionedCallback()}
					/>
				)}

				{(props.sendData?.uploadFileActive ||
					props.sendData?.sendDataActive ||
					props.sendData?.sendComplete) && (
					<StackVertical justify={FlexJustify.Center} gap={FlexGap.Small} align={FlexAlign.Center}>
						<div className='animation-framer' style={{ margin: '10em' }}>
							{!startAnimationComplete && (
								<Lottie
									animationData={sendStart}
									loop={false}
									onComplete={() => setStartAnimationComplete(true)}
								/>
							)}

							{startAnimationComplete && !processAnimationComplete && (
								<Lottie
									animationData={sendProcess}
									loop
									onLoopComplete={() => {
										if (!props.sendData?.uploadFileActive && props.sendData?.sendComplete) {
											setProcessAnimationComplete(true);
										}
									}}
								/>
							)}

							{processAnimationComplete && (
								<Lottie
									animationData={sendEnd}
									loop={false}
									onComplete={() => setEndAnimationComplete(true)}
								/>
							)}
						</div>

						<div className='send-complete-info'>
							<h5 className='text-center mb-xs'>Success</h5>
							<p className='text-center  mb-xl'>Your file will be posted shortly!</p>
							<Button
								title='Close'
								fullWidth
								colour={ColourStateSolid.Primary}
								onClick={() => props.closeCallback()}
							/>
						</div>
					</StackVertical>
				)}
			</StackVertical>
		</Modal>
	);
}

export default SendProcessingWizardModal;
